import { useOperators } from '../lib/operators-api';

interface OperatorPickerProps {
  // Il valore selezionato e' il `fullName` dell'operatore (stringa),
  // salvato come tale in DocumentLine/Document.dataJson per backward compat.
  value: string;
  onChange: (fullName: string) => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  // includeLegacy: di default true. False per restringere ai soli operatori reali
  // (utile se Marco vuole sparire i 6 placeholder dopo training Andrei).
  includeLegacy?: boolean;
}

export function OperatorPicker({
  value,
  onChange,
  disabled,
  placeholder,
  className,
  includeLegacy = true,
}: OperatorPickerProps) {
  const q = useOperators({ active: true, includeLegacy, pageSize: 200 });
  const items = q.data?.items ?? [];

  return (
    <select
      className={className ?? 'block w-full rounded-md border border-slate-300 px-3 py-2 text-sm'}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled || q.isLoading}
    >
      <option value="">{placeholder ?? '— Seleziona operatore —'}</option>
      {/* Reali prima, poi legacy separati visivamente */}
      {items.filter((o) => !o.isLegacy).map((o) => (
        <option key={o.id} value={o.fullName}>
          {o.fullName}
        </option>
      ))}
      {items.some((o) => o.isLegacy) && items.some((o) => !o.isLegacy) && (
        <option disabled>──── Legacy Drive (temp.) ────</option>
      )}
      {items.filter((o) => o.isLegacy).map((o) => (
        <option key={o.id} value={o.fullName}>
          {o.fullName}
        </option>
      ))}
    </select>
  );
}
